import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/kpi/holiday";

/**
 * 放假/调休日历接口
 *
 * 数据由后端定时任务从通用接口同步，商户也可以在页面上手动调整。
 */
export default {
    /** 查询某年的放假/调休安排 */
    queryByYear: (year) => axios.get({url: `${PREFIX_URI}/queryByYear`, data: {year}}),
    /** 手动设置某天：放假 / 调休上班 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除某天的手动设置（回到按周末判断） */
    delete: (date) => axios.del({url: `${PREFIX_URI}/delete`, data: {date}}),
}
